module.exports = __webpack_public_path__ + "static/media/dblog2.c15acef1.jpg";